import React from 'react';
import { Eyebrow, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { DOCTOR_IMAGE } from '../../data/content';
export function About() {
  return <SectionShell tone="white" data-id="element-61" data-mp="12rf08clel4lo">
      <Eyebrow data-id="element-62" data-mp="12qdfthihz5ra">Quién está detrás</Eyebrow>
      <SectionTitle data-id="element-63" data-mp="ypbnzlqwtvzc">Sobre la Dra. Karito</SectionTitle>

      <div className="mt-7 flex flex-col items-center gap-6 sm:flex-row sm:items-start sm:gap-8" data-id="element-64" data-mp="yptk8idkoa79">
        <div className="w-full max-w-[260px] shrink-0 sm:max-w-[220px]" data-id="element-65" data-mp="b08xrpi7mut8">
          <img src={DOCTOR_IMAGE} alt="Retrato de la Dra. Karito, médica creadora de Ruta Enfermedad Renal™" className="w-full rounded-3xl border border-navy-100 object-cover" width={800} height={1000} data-id="element-66" data-mp="61fn04ub5hwr" />
          <p className="mt-3 text-center text-[12px] font-bold uppercase tracking-[0.12em] text-renal-700" data-id="element-67" data-mp="3ngw3d11pzr4r">
            Dra. Karito
          </p>
          <p className="text-center text-[11.5px] font-medium text-navy-600/70" data-id="element-68" data-mp="3jf14023cnntm">
            Creadora de Ruta Enfermedad Renal™
          </p>
        </div>

        <div className="space-y-3.5 text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-69" data-mp="3881ui3anlw47">
          <p data-id="element-70" data-mp="3czbiz0kgutei">Durante años vi a médicos brillantes enfrentarse al mismo problema:</p>
          <p className="font-semibold text-navy-900" data-id="element-71" data-mp="3hy4vapo0oed3">
            No les faltaba conocimiento. Les faltaba una forma rápida de convertir ese conocimiento
            en decisiones clínicas.
          </p>
          <p data-id="element-72" data-mp="2p9h7ambvvavu">
            Las guías responden casi todas las preguntas. Pero rara vez responden la más importante:{' '}
            <em className="font-semibold text-renal-700" data-id="element-73" data-mp="2u80q4dv6k6jz">
              ¿qué hago con el paciente que tengo delante, aquí y ahora?
            </em>
          </p>
          <p data-id="element-74" data-mp="2z5aerraqwe6r">
            Por eso desarrollé Ruta Enfermedad Renal™. No como otro manual para estudiar, sino como
            un sistema práctico que transforma recomendaciones complejas en decisiones claras,
            rápidas y aplicables desde la primera consulta.
          </p>
          <p className="font-display text-[17px] font-bold text-navy-900 sm:text-xl" data-id="element-75" data-mp="2aipswycsvgq7">
            Mi objetivo es que nunca más tengas que decir: “Déjame revisar y luego te respondo.”
          </p>
        </div>
      </div>

      <div className="mt-8" data-id="element-76" data-mp="2jiw9wu7piyu4">
        <CtaButton label="Quiero la ruta de la Dra. Karito" sub="Sistema clínico completo • Pago único de USD 15" data-id="element-77" data-mp="2fj3y88n0ockj" />
      </div>
    </SectionShell>;
}